import {
  actualizarCaracteristica,
  crearCaracteristica,
  eliminarCaracteristica,
  getCaracteristicas,
} from 'api/caracteristica'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import swal from 'sweetalert2'

const key = 'caracteristicas'
export function useObtenerCaracteristica(buscar) {
  return useQuery(key, () => getCaracteristicas(buscar))
}

export function useCrearCaracteristica() {
  const queryClient = useQueryClient()
  return useMutation(crearCaracteristica, {
    onSuccess: (response) => {
      const { data } = response
      queryClient.setQueryData(key, (prevState) => {
        const results = [data, ...prevState.results]
        return { ...prevState, results }
      })
    },
  })
}

export function useActualizarCaracteristica() {
  const queryClient = useQueryClient()
  return useMutation(actualizarCaracteristica, {
    onSuccess: (_, value) => {
      const { id, values: caracteristicaActualizada } = value
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.map((caracteristica) => {
          let nuevaCaracteristica = caracteristica
          if (id === caracteristica.id) {
            nuevaCaracteristica = caracteristicaActualizada
          }
          return nuevaCaracteristica
        })
        return { ...prevState, results }
      })
    },
  })
}

export function useEliminarCaracteristica() {
  const queryClient = useQueryClient()
  return useMutation(eliminarCaracteristica, {
    onSuccess: (_, value) => {
      queryClient.setQueryData(key, (prevState) => {
        const results = prevState.results.filter(
          (caracteristica) => caracteristica.id !== value.id,
        )
        return { ...prevState, results }
      })
    },
  })
}

export function useCaracteristica(onToggle) {
  const queryClient = useQueryClient()
  const { mutateAsync: eliminarCaracteristica } = useEliminarCaracteristica()
  const { mutateAsync: actualizarCaracteristica } = useActualizarCaracteristica()
  const { mutateAsync: crearCaracteristica } = useCrearCaracteristica()

  const handleCrearCaracteristica = async (values, acciones) => {
    try {
      const { data, onSuccessMessage } = await crearCaracteristica(values)
      const message = `La caracteristica ${data.nombre} fue creada satisfactoriamente!`
      onSuccessMessage({ text: message })
      acciones.resetForm()
      onToggle()
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleActualizarCaracteristica = async ({ id, values, acciones }) => {
    try {
      const { data, onSuccessMessage } = await actualizarCaracteristica({
        id,
        values,
      })
      if (data) {
        onSuccessMessage({
          text: 'La caracteristica fue actualizada satisfactoriamente!',
        })
        onToggle()
      }
    } catch (error) {
      acciones.setErrors(error)
    }
  }

  const handleEliminarCaracteristica = (id) => {
    swal
      .fire({
        title: 'Estás seguro?',
        text: 'Recuerda que no podrás revertir estos cambios!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, eliminalo!',
      })
      .then(async ({ value }) => {
        if (value) {
          const { data, onSuccessMessage } = await eliminarCaracteristica(id)
          const message = `La caracteristica ${data} fue eliminada satisfactoriamente!`
          onSuccessMessage({ text: message })
        }
      })
  }

  const handleBuscarCaracteristica = async (value) => {
    queryClient.prefetchQuery(key, () => getCaracteristicas(value))
  }

  return {
    obtenerCaracteristicas: useObtenerCaracteristica,
    handleEliminarCaracteristica,
    handleActualizarCaracteristica,
    handleCrearCaracteristica,
    handleBuscarCaracteristica,
  }
}
